import position from '../../styles/position';

export default {
    errorIcon: {
        cursor: 'pointer',
        position: 'absolute',
        float: 'right',
        top: 16,
        right: 0,
        color: '#999999',
        fontSize: 12,
    },
    container: {
        ...position.inlineBlock,
        position: 'relative',
    },
};
